<template>
  <div class="comp-preach">
    <div class="icon">
      <router-link :to="`${$subsitePrefix}/ss/society/training/detail/${data.Id}`">
        <img @error="imgError" :src="data.Illustration || '/static/img/no-img.png'" :alt="data.Name" />
      </router-link>
    </div>
    <div class="name">{{ data.Name }}</div>
    <div class="desc">
      <span> <i class="el-icon-view"></i>{{ data.ExplorerQty }} </span>
      <span>
        <i class="el-icon-time"></i>{{ formartDate(data.RegistStartTime, "day") }}
      </span>
      <span class="play" v-if="data.LiveTypeId != 0">
        <a :href="data.LiveUrl" target="_blank"><i class="el-icon-video-play"></i>立即观看</a>
      </span>
      <span v-else>线下培训</span>
    </div>
  </div>
</template>

<script>
import toolMixin from "@/mixins/content-tools.js";
export default {
  name: "preach-card",
  props: {
    data: {
      type: Object
    }
  },
  mixins: [toolMixin]
};
</script>

<style lang="scss" scoped>
.comp-preach {
  width: 376px;
  height: 292px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 12px 0px rgba(69, 80, 238, 0.08);
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 24px;
  margin-left: 24px;
  .icon {
    width: 376px;
    height: 176px;
    overflow: hidden;
    border-radius: 8px 8px 0 0;
    transition: all 0.3 ease;
  }
  .name {
    font-size: 18px;
    font-weight: 500;
    line-height: 22px;
    margin: 20px 24px 10px 24px;
    @include ellipsisc(2);
    height: 44px;
  }
  .desc {
    display: flex;
    justify-content: space-between;
    font-size: 15px;
    margin: 0 24px;
    i {
      padding-right: 5px;
    }
    .play {
      color: $primary-color;
      cursor: pointer;
    }
  }
  &:nth-child(3n-2) {
    margin-left: 0;
  }
  &:hover {
    box-shadow: 0px 4px 12px 0px rgba(69, 80, 238, 0.16);
  }
}
</style>
